import { createBrowserClient } from "@supabase/ssr";
import type { Database } from "@scoreach/db";
import { env } from "@/lib/config/env";

/**
 * Creates a Supabase client for use in browser (client components).
 * Uses anon key — all queries go through RLS.
 * Safe to call multiple times; @supabase/ssr deduplicates internally.
 */
export function createClient() {
  return createBrowserClient<Database>(env.SUPABASE_URL, env.SUPABASE_ANON_KEY);
}
